import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../../../shared/core2Config';
import { bl_del_job_shipment_link_RowClass, JobShipmentLinkContainerModel } from '../../../../../../../models';
import { ApiResponseModel, ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../../shared/base-api-public-login-template.service';

@Injectable({
    providedIn: 'root'
  })
export class JobShipmentLinkService extends BaseApiPublicLoginTemplateService<JobShipmentLinkContainerModel, JobShipmentLinkContainerModel, JobShipmentLinkContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/region-comp-branch-location-links
  // https://api.akaun.com/core2/tnt/dm/delivery-shipment-hdr/public-ep/TNL-TEG-OMIT-6777388

  //todo: del/ or no del/ ?
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipment-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipment-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipment-links/backoffice-ep';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-shipment-links/public-ep';
    this.httpClient = http;
  }

  getByTrackingIdPublicEp(
    trackingId: string,
    apiVisa: ApiVisa
  ): Observable<ApiResponseModel<bl_del_job_shipment_link_RowClass>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_public_url;
    }
    return this.httpClient.get<ApiResponseModel<bl_del_job_shipment_link_RowClass>>(
      this.apiUrl + '/' + trackingId,
      this.getHttpHeader(apiVisa)
    );
  }
}